import { WarningSolid } from '@dronebase/shared-ui-icons';
import { Alert, Button, Stack, Text, Title } from '@mantine/core';
import { redirect, useNavigate, useSearchParams } from 'react-router-dom';

import { HorizontalDividerWithLabel } from 'components/common/Divider/HorizontalLabelDivider';
import { CardContentContainer } from 'components/Layout/AuthPagesLayout';
import { ROUTES } from 'lib/constants/routes';
import { getCookie } from 'lib/cookies';
import {
    ASSET_INSIGHTS_BUTTON_LABEL,
    checkLoggedIn,
    getAssetInsightsUrl,
    getDecommissionMessage,
    getDecommissionTitle,
    shouldShowDecommissionBanner,
} from 'lib/helpers';

import LoginForm from './LoginForm';
import { SingleSignOn } from './SingleSignOn';

const LoginPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const showDecommissionBanner = shouldShowDecommissionBanner(searchParams.get('decommissioned') === 'true');

    return (
        <CardContentContainer>
            {showDecommissionBanner && (
                <Alert color="yellow" variant="light" radius="md" mb="md">
                    <Stack align="center" spacing="sm">
                        <WarningSolid color="#E8A23D" height="2rem" width="2rem" />
                        <Text fw={700} ta="center" size="md">
                            {getDecommissionTitle()}
                        </Text>
                        <Text ta="center" size="sm" color="dimmed">
                            {getDecommissionMessage()}
                        </Text>
                        <Button component="a" href={getAssetInsightsUrl()} variant="filled">
                            {ASSET_INSIGHTS_BUTTON_LABEL}
                        </Button>
                    </Stack>
                </Alert>
            )}

            <Title order={6} ta="center">
                Log in
            </Title>

            <LoginForm />

            <HorizontalDividerWithLabel label="or" color="gray.1" labelColor="gray.4" />

            <SingleSignOn onSuccessCallback={() => navigate(ROUTES.auth.select_workspace)} />
        </CardContentContainer>
    );
};

export default LoginPage;

export const loginLoader = async () => {
    if (await checkLoggedIn()) {
        const workspaceID = getCookie('helio-workspace')?.id;
        const userId = getCookie('helio-userId');

        if (workspaceID) {
            const url = `${window.location.origin}/sites`;

            window.location.replace(url);

            return redirect(url);
        } else if (userId) {
            return redirect(ROUTES.auth.select_workspace);
        }
    }

    return null;
};
